import script from "./RateDateIdeas.vue?vue&type=script&setup=true&lang=js"
export * from "./RateDateIdeas.vue?vue&type=script&setup=true&lang=js"

import "./RateDateIdeas.vue?vue&type=style&index=0&id=8bb2c4e6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bb2c4e6"]])

export default __exports__